//Generated File 
export default class TrueFalseNotSpecified{
	static readonly False = `False`;
	static readonly NotSpecified = `NotSpecified`;
	static readonly True = `True`;
}
